import { Funcionario } from 'src/app/core/funcionario';
import { GrupoAcoesSimples } from './grupo-acoes-simples';
import { MateriaisAcao } from './materiais-acao';
import { MetaAcao } from "./meta-acao";
import { PlanejamentoOficina } from './planejamento-oficina';
import { UsuarioSistema } from './usuario-sistema';

export class AcoesPlanejamentoOficina {
    id: number;

    dataFim: Date;
    dataInicio: Date;
    dataAprovaAcao: Date;

    descricao: string;
    descricaoObjetivoAcao: string;
    descricaoMetodologiaAcao: string;
    descricaoAvaliacaoAcao: string;
    descricaoOcorrenciaAcao: string;

    planejamentoOficina: PlanejamentoOficina;

    funcionarioPlanejamentoAcao: Funcionario;
    funcionarioAprovaAcao: Funcionario;
    funcionarioExecutaAcao: Funcionario;
    usuarioAlteracao: number;

    materiaisAcao: MateriaisAcao[];
    localExecucao: string;

    grupoAcao: GrupoAcoesSimples;
    statusAnalise: string;
    dataAnalise: Date;
    usuarioAnalise: UsuarioSistema;	

    recursosPedagogicos: string;
    qtdParticipantes: number;

    metas: MetaAcao[];

}